export default {
  CaregiverHappinessQuestion: 'How happy are you with your caregiver today?',
  CareQuiltHappinessQuestion: 'How happy are you with CareQuilt overall?',
  HappinessResponse: {
    Happy: 'Happy',
    Neutral: 'Neutral',
    Unhappy: 'Unhappy',
  },
  CanWeImprove: {
    Title: 'Is there anything we can improve?',
    RelevantTopicsSubtitle: 'Select relevant topics (optional)',
    Topics: {
      Quality: 'Quality of Care',
      Punctuality: 'Punctuality',
      Communication: 'Communication',
      Professionalism: 'Professionalism',
      Scheduling: 'Scheduling',
      Billing: 'Billing',
      Other: 'Other',
    },
    AdditionalCommentsSubtitle: 'Additional Comments:',
    AdditionalCommentsPlaceholder: 'Share your thoughts here...',
  },
  FollowUp: {
    Question: 'We\'re sorry your experience wasn\'t optimal. Would you like us to follow up with you?',
    YesLabel: 'Yes, please follow up',
    BestContactTime: {
      Title: 'Best time to contact you:',
      Unselected: 'Select a time',
      Morning: 'Morning (8 AM - 12 PM)',
      Afternoon: 'Afternoon (12 PM - 5 PM)',
      Evening: 'Evening (5 PM - 8 PM)',
    },
    NoLabel: 'No, thanks',
  },
  PrivacyRequiredLabel: 'Keep my comments private (don\'t share with my caregiver).',
  PrivacyRequiredHoverDialogue: 'If left unchecked, CareQuilt may share these comments with your caregiver for coaching and quality improvement.',
  SendFeedback: 'Send feedback',
  SendFeedbackPrompt: 'Please rate your caregiver to continue',
  ThankYou: {
    Title: 'Thank you!',
    Message: 'We review every response. If you asked for a follow-up, our care team will contact you.',
  },
};
